import React from 'react'
import classnames from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'

// @TODO Move these components to Content directory
// https://aussiecommerce.atlassian.net/browse/ENGX-247
import Content from 'components/Pages/LandingPage/Content'
import Hero from 'components/Pages/LandingPage/Hero'
import LegalPage from 'components/Pages/LandingPage/Hub/Legal'
import NavigationBar from 'components/Pages/LandingPage/Hub/NavigableBar'
import OffersLoaderWithSearchContext from 'components/Pages/LandingPage/Hub/OffersLoaderWithSearchContext'
import AdditionalGuides from 'components/Pages/LandingPage/Hub/AdditionalGuides/AdditionalGuides'
import BannersLoader from 'components/Pages/LandingPage/Hub/BannersLoader'
import OfferMap from 'components/Pages/LandingPage/Hub/OfferMap'
import DiscoverGuideMap from 'components/Pages/LandingPage/Hub/DiscoverGuideMap'
import DiscoverGuideArticles from 'components/Pages/LandingPage/Hub/DiscoverGuideArticles'
import Login from 'components/Pages/LandingPage/Hub/Login'
import KeyMessageTiles from 'components/Common/KeyMessageTile/KeyMessageTiles'
import config from 'constants/config'
import ExperienceOffersLoader from 'components/Pages/LandingPage/Hub/ExperienceOffersLoader'
import filterCruiseContent from 'lib/cruises/contentfulCruiseFilter'
import ErrorBoundary from 'components/Common/ErrorBoundary'
import ContentfulCardCarousel from 'marketing/pages/ContentfulWebPage/ContentfulCardCarousel'
import { VideoClip } from 'components/VideoClip/VideoClip'
import ContentfulValuePropositionBanner from 'marketing/pages/ContentfulWebPage/ContentfulValuePropositionBanner'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import { renderMarkdown } from 'lib/string/markdownUtils'

const Section = styled.div`
  margin-top: ${rem(40)};

  &.componentContent.componentNavigationItems,
  &.componentDiscoverGuideArticles.componentNavigationItems,
  &.componentDiscoverGuideArticles.componentDiscoverGuide,
  &.componentDiscoverGuideArticles.componentDiscoverGuideArticles,
  &.componentContent.componentOfferMap,
  &.componentCruiseOffersLoader.componentDiscoverGuideArticles {
    margin-top: 0;
  }
`

function ContentBlock(props) {
  const {
    hubPage,
    sections,
    section,
    i,
    previousContent,
    isLoggedIn,
    regionCode,
    magazineArticles,
    shouldShowMagazineArticle,
  } = props
  const className = classnames(section.contentTypeId, sections[i - 1]?.contentTypeId)

  switch (section.contentTypeId) {
    case 'componentHero':
      return <Hero
        {...section}
        key={section.contentTypeId}
        typeOfPage="pageContentHub"
        version={section?.type === 'outsideImage' ? 'hub' : 'landing'}
        back={{
          link: previousContent ? `/${previousContent.slug}.p1` : '/',
          title: previousContent ? previousContent.title : 'View all offers',
        }}
        metaData={{
          title: `${config.title} ${regionCode}`,
          description: section.subTitle,
        }}
      />
    case 'componentBannersLoader':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <BannersLoader
          {...section}
        />
      </Section>
    case 'componentNavigationItems':
      return <NavigationBar
        {...section}
        key={section.contentTypeId}
        magazineArticles={magazineArticles}
        shouldShowMagazineArticle={shouldShowMagazineArticle}
      />
    case 'componentOffersLoader':
      let sortBy = undefined
      if (section.filters.strategyApplied === 'home' ||
          section.filters.strategyApplied === 'vertical-hotel' ||
          section.filters.strategyApplied === 'vertical-tour' ||
          section.filters.strategyApplied === 'vertical-cruise' ||
          section.filters.strategyApplied === 'newest'
      ) {
        sortBy = section.filters.strategyApplied
      }
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <OffersLoaderWithSearchContext
          {...section}
          filters={{
            campaigns: section.filters.campaigns,
            placeIds: section.placeIds ?? [ANYWHERE_PLACE_ID],
            holidayTypes: section.filters.holidayTypes,
            sortBy,
            useUnifiedSearchEndpoint: true,
          }}
          offerTypes={section.offerTypes}
          content={hubPage}
        />
      </Section>
    case 'componentExperiencesOffersLoader':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <ExperienceOffersLoader {...section} />
      </Section>
    case 'componentCruiseOffersLoader':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <OffersLoaderWithSearchContext
          {...section}
          filters={filterCruiseContent(section)}
          offerTypes={['cruise']}
          content={hubPage}
        />
      </Section>
    case 'componentContent':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <Content
          {...section}
        />
      </Section>
    case 'componentTileNavigation':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <AdditionalGuides
          {...section}
        />
      </Section>
    case 'componentOfferMap':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <OfferMap
          {...section}
        />
      </Section>
    case 'componentDiscoverGuide':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <DiscoverGuideMap
          {...section}
        />
      </Section>
    case 'componentDiscoverGuideArticles':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <DiscoverGuideArticles
          {...section}
        />
      </Section>
    case 'componentLogin':
      if (!isLoggedIn) {
        return (
          <Section
            id={section.hash}
            key={section.hash}
            className={className}
          >
            <Login
              {...section}
            />
          </Section>
        )
      } else if (section.content) {
        return (
          <Section
            id={section.hash}
            key={section.hash}
            className={className}
          >
            <ErrorBoundary fallback={null}>
              <ContentBlock
              hubPage={section.content.fields}
              sections={sections}
              section={{
                contentTypeId: section.content.sys.contentType.sys.id,
                ...section.content.fields,
              }}
              />
            </ErrorBoundary>
          </Section>
        )
      }
      return null
    case 'componentKeyMessageTiles':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >``
        <KeyMessageTiles
          {...section}
        />
      </Section>
    case 'legalPages':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}
      >
        <LegalPage content={section.pageContent} title={section.title} />
      </Section>
    case 'componentCardCarousel':
      const title = renderMarkdown(section.title)
      return <Section
      id={section.hash}
      key={section.hash}
      className={className}>
        <ContentfulCardCarousel
          title={title}
          subtitle={section.subtitle}
          cardItems={section.cardItems.map((cardItem) => cardItem.fields)}
          viewAllLink={section.viewAllLink}
          isLargeContentWrapper={section.isLargeContentWrapper}
        />
      </Section>
    case 'componentValuePropositionBanner':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}>
        <ContentfulValuePropositionBanner title={section.title} items={section.items.map(item => item.fields)} />
      </Section>
    case 'componentVideoClip':
      return <Section
        id={section.hash}
        key={section.hash}
        className={className}>
        <VideoClip videoUrl={section.videoUrl} title={section.title} align={section.align} />
      </Section>
    default:
      return section.contentTypeId ? <div>The component {section.contentTypeId} has not been created yet.</div> : null
  }
}

export default ContentBlock
